import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import withLoader from '../../components/Loader/withLoader.js';
import { getLoadedStatus } from '../../helpers/loaderHelpers';
import { getString } from '../../helpers/stringHelpers.js';
import { isFeatureDisabled } from '../../helpers/outageHelpers';
import HomeIcon from '@material-ui/icons/Home';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import ViewColumnOutlinedIcon from '@material-ui/icons/ViewColumnOutlined';
import WhatshotIcon from '@material-ui/icons/Whatshot';

// Actions
import { actions as routingActions } from '../../ducks/routing.js';
import { actions as authActions } from '../../ducks/auth.js';
import { actions as appActions } from '../../ducks/app.js';
import { actions as customerActions } from '../../ducks/customer.js';

// Components
import ApplicationLandingLayout from './ApplicationLandingLayout';
import ApplicationLandingCard from './ApplicationLandingCard/ApplicationLandingCard';

const stringsComponent = 'applications';

class ApplicationLanding extends React.Component {
  componentDidMount() {
    const { setAppBarTitle, onLoadComplete } = this.props;

    setAppBarTitle(getString(stringsComponent, 'TITLE'));
    onLoadComplete();
  }

  shouldComponentUpdate(nextProps) {
    // Only rerender if not in a unloaded status.
    if (getLoadedStatus(this.getLoadedStatuses(nextProps)) !== 'UNLOADED') {
      return true;
    }
    return false;
  }

  getLoadedStatuses(props = this.props) {
    const { tenancy } = props;
    const loaded = [tenancy.loaded];

    return loaded;
  }

  render() {
    const { goApplicationChild, goDash, tenancy } = this.props;

    const applicationCards = [];

    applicationSections.forEach((section, i) => {
      let icon;
      switch (section.icon) {
        case 'Truck':
          icon = LocalShippingIcon;
          break;
        case 'Fence':
          icon = ViewColumnOutlinedIcon;
          break;
        case 'Fire':
          icon = WhatshotIcon;
          break;
        case 'House':
        default:
          icon = HomeIcon;
          break;
      }
      applicationCards.push(
        <ApplicationLandingCard
          title={section.title}
          summary={section.summary}
          slug={section.slug}
          icon={icon}
          image={section.image}
          imageAlt={section.imageAlt}
          action={goApplicationChild}
        />
      );
    });

    const WrappedApplicationLandingLayout = withLoader(
      ApplicationLandingLayout
    );

    return (
      <WrappedApplicationLandingLayout
        applicationCards={applicationCards}
        disabledMessage={portalContent.APPLICATIONS_OFF_MESSAGE}
        disabled={isFeatureDisabled('FENCING_WRITE', tenancy.data.area)}
        backAction={goDash}
        loaded={this.getLoadedStatuses()}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  tenancy: state.customer.tenancy,
  inOutage: state.app.inOutage,
  outageFrom: state.app.outageFrom,
  outageTo: state.app.outageTo,
  outageMessage: state.app.outageMessage,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...routingActions,
      ...appActions,
      ...authActions,
      ...customerActions,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ApplicationLanding);
